import React, { useContext } from 'react'
import { EngagementLetterContext } from './EngagementLetter'
import { Stack, TextField, Typography } from '@mui/material'

const CancellationTerms = () => {
  const { engagementLetter, setEngagementLetter } = useContext(
    EngagementLetterContext
  )

  return (
    <Stack>
      <Typography variant="title3">Cancellation Terms</Typography>
      <TextField
        value={engagementLetter.cancellationTerms}
        onChange={(e) =>
          setEngagementLetter((prev) => ({
            ...prev,
            cancellationTerms: e.target.value,
          }))
        }
        minRows={2}
        multiline
      />
    </Stack>
  )
}

export default CancellationTerms